// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* One */
.about-containerOne {
    display: flex;
    column-gap: 70px;
    margin: 0px 10%;
    margin-top: 250px;
    margin-bottom: var(--margin-bottom-web);
}

.about-container-one {
    width: 50%;
    padding-right: 50px;
}

.about-container-subone {
    font-size: 28px;
    font-weight: 800;
    line-height: 35.28px;
    margin-top: 0px;
    margin-bottom: 0px;
}

.about-container-subtwo {
    margin-top: 12px;
    margin-bottom: 0px;
    line-height: 83px;
    font-size: 70px;
    font-weight: 200;
}

.about-container-subthree {
    margin: 0px;
    font-size: 70px;
    font-weight: 800;
    line-height: 1;
}

.about-container-subfour {
    margin-top: 26px;
    margin-bottom: 45px;
    font-size: 30px;
    font-weight: 500;
    line-height: 42px;
    letter-spacing: 4%;
}

.about-container-subfive {
    display: flex;
    gap: 13px;
    line-height: 1;
}

.about-container-btnone,
.about-container-btntwo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    border-radius: 50px;
    font-size: 18px;
}

.about-container-btnone {
    padding: 25px, 52px, 26px, 52px;
    width: 196px;
    color: white;
    background-color: #20303F;
    border: none;

}

.about-container-btntwo {
    width: 216px;
    color: black;
    background-color: white;
    padding-left: 8px, 10px, 8px, 10px;
}

.about-container-two {
    width: 100%;
    height: 500px;
    width: 500px;
    display: flex;
}

.about-container-two img {
    padding-top: 40px;
    margin-bottom: -75px;
    width: 100;
}

/* media 1 */

@media (max-width: 1280px) {
    .about-containerOne {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: auto;
        padding: 0px;
        margin-top: 0px;
    }

    .about-container-one {
        width: 100%;
        padding-right: 50px;
    }

    .about-container-two {
        margin-left: 0px;
    }
}

@media (max-width: 500px) {
    .about-containerOne {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        overflow: hidden;
        margin-top: 0px;
    }

    .about-container-subone {
        margin-top: 0px;
        font-size: 14px;
    }

    .about-container-subtwo {
        width: 100vw;
        margin-top: 6px;
        margin-bottom: 0px;
        line-height: 1;
        font-size: 35px;
        font-weight: lighter;
    }

    .about-container-subthree {
        width: 80vw;
        margin-top: 5px;
        font-size: 35px;
    }

    .about-container-subfour {
        width: 80vw;
        margin-top: 13px;
        margin-bottom: 23px;
        font-size: 16px;
        font-weight: normal;
        line-height: 20px;
    }

    .about-container-two {
        width: 75%;
    }

    .about-container-two img {
        width: 100vw;
        height: 40vh;
    }

    .about-container-btnone,
    .about-container-btntwo {
        height: 45px;
        font-size: 10px;
        padding: 0%;
    }

    .about-container-btnone {
        width: 120px;
        color: white;
    }

    .about-container-btntwo {
        width: 130px;
        color: black;
    }
    .about-container-two {
        height: auto;
    }
}

/* two */

.about-containerTwo {
    width: 100%;
    margin-bottom: var(--margin-bottom-web);
    position: relative;
}

.HadnShakeimg {
    width: 100%;
    object-fit: cover;
    clip-path: polygon(10% 0%, 100% 0%, 100% 80%, 90% 100%, 0% 100%, 0% 20%);
}

.about-containerTwo-one {
    position: absolute;
    bottom: -50px;
    left: 28%;
    transform: translateX(-50%);
    background: #0B63E5;
    color: white;
    border-top-right-radius: 50px;
    padding: 1% 2% 1% 2%;
    width: 35%;
}

.logoT {
    width: 120px;
    height: 25px;
}

.about-containerTwo-line1 {
    margin-top: 20px;
    margin-bottom: 0px;
    font-size: 20px;
    font-weight: bold;
}

.about-containerTwo-line2 {
    margin-top: 0px;
    font-size: 40px;
    font-weight: lighter;
    margin-bottom: 0px;
}

.about-containerTwo-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.getConnected-button {
    font-size: 15px;
    font-weight: bold;
    color: white;
    background-color: #20303F;
    padding: 20px 40px 20px 40px;
    border: none;
    border-radius: 50px;
}

.about-containerTwo-bottom>img {
    width: 20%;
}

/* Media for 2nd */
@media (max-width: 1280px) {

    .about-containerTwo {
        height: 300px;
    }

    .HadnShakeimg {
        clip-path: polygon(5% 0%, 100% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 20%);
    }

    .about-containerTwo-one {
        top: 70px;
        left: 50%;
        border-radius: 0%;
        padding: 1% 1% 4% 2%;
        width: 75vw;
        height: 60%;
    }

    .logoT {
        width: 70px;
        height: 15px;
    }

    .about-containerTwo-line1 {
        margin-top: 12px;
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: 700;
    }

    .about-containerTwo-line2 {
        font-size: 25px;
        line-height: 30px;
        font-weight: 200;
    }

    .about-containerTwo-line2 span {
        font-size: 25px;
        line-height: 30px;
        font-weight: 800;
    }

    .getConnected-button {
        padding: 10.42px 21.67px 10.83px 21.67px;
        font-size: 14px;
        font-weight: 800;
        line-height: 20.37px;
    }

    .about-containerTwo-bottom>img {
        width: 10%;
        margin-top: 4%;
        height: 70px;
    }
}

@media (max-width: 500px) {
    .about-containerTwo {
        margin-top: -100px;
        margin-bottom: 400px;
    }

    .about-containerTwo {
        height: 400px;
        overflow: hidden;
    }

    .HadnShakeimg {
        width: 100%;
        object-fit: cover;
        clip-path: polygon(10% 0%, 100% 0%, 100% 80%, 90% 100%, 0% 100%, 0% 20%);
    }

    .about-containerTwo-one {
        top: 70px;
        left: 50%;
        height: 250px;
        width: 280px;
        padding: 5% 5% 4% 2%;
    }

    .about-containerTwo-bottom>img {
        width: 20%;
        margin-top: 5%;
        height: 50px;
    }

}


/* 3 */

.about-containerThree {
    margin: 0px 10%;
    margin-bottom: var(--margin-bottom-web);
    display: flex;
    column-gap: 10px;
}

.about-containerThree-Container {
    width: 50%;
}

.about-containerThree-Line1 {
    font-size: 25px;
    font-weight: bold;
    margin-top: 35px;
}

.about-containerThree-Line2 {
    font-size: 23px;
    margin-bottom: 0px;
    margin-top: 36px;
    line-height: 1.5;
}

.about-containerThree-Line3 {
    font-weight: bolder;
    font-style: italic;
}

.about-containerThree-Line4 {
    font-weight: bold;
    display: block;
}

.about-containerThree-Container2 {
    display: flex;
    justify-content: right;
}

.about-containerThree-three {
    background-color: #F3F7FF;
    width: 50%;
}

.about-containerThree-threeone {
    margin-top: -12%;
    padding: 1%;
    display: flex;
    font-size: 24px;
    column-gap: 15px;
}

.about-containerThree-threeone img {
    margin-top: 60%;
    height: 85%;
}

.about-containerThree-threeone-logo {
    margin: -10px -10px 0px 0px;
    display: flex;
    justify-content: right;
}

.about-containerThree-threeone-line1 {
    font-weight: bolder;
    margin-top: 15px;
}

.about-containerThree-threeone-line2 {
    font-weight: bold;
    margin-top: 9%;
}

.about-containerThree-threeone-line2+p {
    margin-top: 80px;
}

/* Media for 3rd */
@media (max-width: 1280px) {
    .about-containerThree {
        margin-top: 90px;
        display: flex;
        flex-direction: column;
    }

    .about-containerThree-Container {
        width: 100%;
        margin-top: 2%;
    }

    .about-containerThree-three {
        background-color: #F3F7FF;
        width: 100%;
    }

    .about-containerThree-threeone-logo {
        margin: -25px -25px 0px 0px;
    }
}


@media (max-width: 500px) {
    .about-containerThree {
        margin-top: -350px;
    }

    .about-containerThree-Line1 {
        margin-top: 0px;
        font-size: 15px;
        font-weight: 800;
        line-height: 18px;
    }

    .about-containerThree-Line2 {
        margin-top: 20px;
        font-size: 15px;
        font-weight: 400;
        line-height: 18px;
    }

    .about-containerThree-Line3 {
        font-weight: 800;
    }

    .about-containerThree-Container2 img {
        width: 100%;
    }

    .about-containerThree-threeone {
        padding: 1%;
        padding-top: 30px;
        font-size: 12px;
        font-weight: 700;
        line-height: 15.29px;
        height: 250px;
    }

    .about-containerThree-threeone-line1 {
        margin-top: 10px;
    }

    .about-containerThree-threeone-line2 {
        font-size: 12.14px;
        font-weight: 600;
        line-height: 18.27px;
    }

    .about-containerThree-threeone-line2+p {
        margin-top: 30px;
    }

    .about-containerThree-threeone img {
        padding-left: 10%;
        margin-right: 15px;
        margin-top: 10px;
        height: 100%;
    }

    .about-containerThree-threeone {
        column-gap: 0px;
    }

    .about-containerThree-threeone-logo {
        height: 60px;
        margin: -20px -10px 0px 0px;
    }


}

/* 4 */
.about-containerFour {
    margin-bottom: var(--margin-bottom-web);
}

.about-containerFour-headLines {
    margin: 0% 10%;
    font-size: 45px;
    font-weight: 200;
    text-align: center;
}

.about-containerFourPhoto img {
    width: 100px;
    margin-bottom: -20px;
}

.about-containerFourbottom {
    font-size: 36px;
    text-align: center;
}

.about-containerFourbottom-IT>img {
    margin-bottom: -2px;
}

.about-containerFourbottompart2 {
    font-weight: bolder;
}

.about-containerFourbottom2 {
    text-align: center;
    margin-top: -20px;
}

/* Media  4*/

@media (max-width: 1280px) {
    .about-containerFour-headLines {
        margin: 0% 15%;
        font-size: 30px;
        line-height: 2;
    }

    .about-containerFourPhoto img {
        width: 60px;
        margin-bottom: -15px;
    }
}

@media (max-width: 500px) {
    .about-containerFour {
        margin-top: -100px;
        margin-bottom: -200px;
    }

    .about-containerFour-headLines {
        margin: 0% 10%;
        font-size: 18.17px;
        font-weight: 200;
        line-height: 30.29px;
        margin-top: 50px;
    }

    .about-containerFourPhoto img {
        width: 40px;
        margin-bottom: -15px;
    }


    .about-containerFourbottom {
        font-size: 14px;
        font-weight: 200;
        line-height: 12.11px;
        margin-top: 40px;
    }

    .about-containerFourbottom2 {
        margin-top: -10px;
    }

    .about-containerFourbottom-IT img {
        width: 0.6rem;
    }
}




/* 5 */
.about-containerFive {
    background-color: #0B63E5;
    margin-bottom: var(--margin-bottom-web);
    font-size: 20px;
    color: white;
    font-weight: 500;
}

.about-containerFivePartone {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.about-containerFiveParttwo {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.about-containerFivePartone-icon {
    margin-top: 12px;
}

.about-containerFivePartone-item {
    display: flex;
    align-items: center;
}

/* Media5 */

@media (max-width: 1280px) {
    .about-containerFivePartone {
        display: grid;
        grid-template-columns: repeat(5, 4fr);
    }

    .about-containerFivePartone div {
        justify-content: space-around;
        margin: 0% 5%;
    }

    .about-containerFiveParttwo {
        border-top: 2px solid;
        display: grid;
        grid-template-columns: repeat(3, 4fr);
        margin: 0% 1%;
    }

    .about-containerFiveParttwo div {
        display: flex;
        justify-content: space-between;
    }
}

@media (max-width: 500px) {
    .about-containerFivePartone {
        font-size: 8px;
        font-weight: 500;
        line-height: 15.85px;
    }

    .about-containerFiveParttwo {
        font-size: 8px;
        font-weight: 500;
        line-height: 15.85px
    }

}


/* 6 */

.about-containerSix {
    width: 80%;
    display: flex;
    margin: auto;
    margin-bottom: var(--margin-bottom-web);
    /* column-gap: 50px; */
}

.about-containerSix-one {
    width: 60%;
}

.about-containerSix-one-info {
    font-size: 48px;
}

.about-containerSix-one-Title {
    margin: 0px;
    font-size: 31.39px;
    font-weight: 200;
    line-height: 35.32px;
}

.about-containerSix-one-Subtitle {
    font-weight: bolder;
    margin: 0px;
}

.about-containerSix-one-data {
    margin-top: 75px;
    display: flex;
    column-gap: 1%;
    padding-right: 1%;
}

.dataimg {
    height: 45px;
    width: 48px;
}

.about-containerSix-one-dataTitle {
    font-size: 28px;

}

.about-containerSix-one-datasubtitle {
    font-size: 20px;
}

.about-containerSix-two img {
    width: 100%;
    height: 95%;
}

/* media 6 */

@media (max-width: 1280px) {
    .about-containerSix {
        flex-direction: column;
    }

    .about-containerSix-one {
        width: 100%;
    }

    .about-containerSix-one-data {
        margin-top: 50px;
        display: flex;
        column-gap: 1%;
        justify-content: space-between;
        padding-right: 0px;
        column-width: 100px;
    }

    .about-containerSix-two {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .about-containerSix-two img {
        width: 80%;
        margin-top: 70px;
        border-top: 1px solid;
    }

    .about-containerSix-one-data>div {
        width: 100%;
    }

}

@media (max-width: 500px) {
    .about-containerSix {
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        margin-bottom:80px;
    }
    

    .about-containerSix-one {
        width: 100%;
    }

    .about-containerSix-one-info {
        font-size: 31.39px;
        line-height: 35.32px;
    }

    .about-containerSix-one-Subtitle {
        font-weight: 800;
    }

    .about-containerSix-one-data {
        flex-direction: column;
    }

    .about-containerSix-one-data-media {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }

    .about-containerSix-one-data {
        margin-top: 30px;
    }

    .about-containerSix-one-data>div {
        border-top: 1px solid;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .about-containerSix-one-dataTitle {
        font-size: 16px;
        font-weight: 500;
        line-height: 18.13px;
    }

    .about-containerSix-one-datasubtitle {
        font-size: 13.08px;
        font-weight: 400;
        line-height: 19.68px;
    }

    .about-containerSix-two {
        width: 100%;
        display: flex;
        margin-top: 20px;
        border-top: 1px solid;
    }

    .about-containerSix-two img {
        width: 100%;
        margin: auto;
    }

    .dataimg {
        width: 15%;
    }
}



/* 7 */
.about-containerSeven {
    padding: 0% 10%;
    background-color: #0B63E5;
    margin-bottom: var(--margin-bottom-web);
}

.about-containerSeven-one {
    font-size: 48px;
    padding-top: 120px;
    color: white;
    text-align: center;
    font-family: Plus Jakarta Sans;
}

.about-containerSeven-oneTitle {
    font-weight: lighter;
    margin-bottom: 0px;
    margin-top: 0px;
}

.about-containerSeven-oneSubtitle {
    font-weight: bold;
    margin-top: 0px;
}

.about-containerSeven-two {
    display: flex;
    column-gap: 30px;
    margin-bottom: 45px;
}

.about-containerSeven-two div {
    background-color: white;
    border-radius: 10px;
}

.about-containerSeven-twoBlog {
    padding: 3% 2%;
    display: flex;
    flex: 1 1;
    flex-direction: column;
    justify-content: space-between;
}

.about-containerSeven-two-blog {
    display: flex;
    justify-content: space-between;
    column-gap: 20px;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-weight: bold;

    & img {
        cursor: pointer;
    }
}

.about-containerSeven-two-blog div>p {
    margin-top: 0px;
    margin-bottom: 25px;
}

.about-containerSeven-twoBlog-info {
    font-size: 20px;
    font-weight: normal;
}

.about-containerSeven-twoBlog-info p {
    margin-top: 0px;
    margin-bottom: 45px;
}

.about-containerSeven-twoBlog-Person {
    display: flex;
    column-gap: 15px;
    align-items: center;
}

.about-containerSeven-twoBlog-Person div img {
    width: 72px;
}

.about-containerSeven-twoBlogName p {
    font-size: 24px;
    line-height: 25px;
    margin-top: 0px;
    margin-bottom: 0px;
}

.about-containerSeven-twoBlogPosition p {
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 0px;
    line-height: 25px;
}

.about-containerSeven-Three {
    display: flex;
    justify-content: space-between;
}

.about-containerSeven-Three {
    font-size: 36px;
    font-weight: 600;
    margin-top: 27px;
    color: white;
    margin-bottom: 0px;
}

.about-containerSeven-Three p {
    margin-top: 0px;
    padding-bottom: 20px;
}

.ViewCareers-button {
    font-size: 18px;
    font-weight: bolder;
    color: white;
    background-color: #20303F;
    padding: 5px 40px;
    border: none;
    border-radius: 50px;
    height: 70px;
}

/* key */
@keyframes scroll {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(-100%);
    }
}

#marquee {
    display: flex;
    animation: scroll 20s linear infinite;
}

/* media7 */
@media (max-width: 1280px) {

    .about-containerSeven {
        height: auto;
        padding: 0%;
        overflow: scroll;
    }

    .about-containerSeven-two {
        justify-content: space-around;
    }

    #marquee .about-containerSeven-twoBlog {
        white-space: normal;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .ViewCareers-button {
        width: 50%;
        padding: 11.79px 24.53px 12.27px 24.53px;
        gap: 8.57px;
        font-size: 18px;
        font-weight: 800;
        line-height: 20px;
    }
}

@media (max-width: 500px) {
    .about-containerSeven {
        padding: 5% 4% 10% 4%;
        overflow: scroll;
        margin-bottom:0px;
    }

    .about-containerSeven-one {
        font-size: 32px;
        padding-top: 50px;
        font-weight: 200;
        line-height: 24.54px;
    }

    .about-containerSeven-oneTitle {
        font-weight: 200;
        margin-bottom: 20px;
    }

    .about-containerSeven-oneSubtitle {
        font-weight: 800;
    }

    .about-containerSeven-two {
        display: flex;
        column-gap: 50px;
    }

    .about-containerSeven-two-blog {
        font-size: 20.6px;
        font-weight: 700;
        line-height: 22.53px;
    }

    .about-containerSeven-twoBlog-info {
        font-size: 12.88px;
        font-weight: 400;
        line-height: 17.63px;
        margin-bottom: -30px;
    }

    .about-containerSeven-twoBlogName p {
        font-size: 15.45px;
        font-weight: 700;
        line-height: 16.53px;
    }

    .about-containerSeven-twoBlogPosition p {
        font-size: 12.88px;
        font-weight: 400;
        line-height: 16.46px;
    }

    .about-containerSeven-twoBlog-Person div img {
        width: 50px;
    }

    .about-containerSeven-two-blog img {
        width: 60px;
    }

    .about-containerSeven-twoBlog {
        display: flex;
        flex: 1 1;
    }

    #marquee .about-containerSeven-twoBlog {
        display: inline-block;
        white-space: normal;
        display: flex;
        flex: 1 1;
        flex-direction: column;
        justify-content: space-between;
    }

    /*Last  */
    .about-containerSeven-Three {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .about-containerSeven-Three p {
        margin-bottom: 0px;
    }


    .about-containerSeven-Three {
        padding-bottom: 10px;
        margin-bottom: 0px;
        font-size: 21px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .ViewCareers-button {
        height: 50px;
        width: 50%;
        padding: 11.79px 24.53px 12.27px 24.53px;
        gap: 8.57px;
        font-size: 11.01px;
        font-weight: 800;
        line-height: 16.02px;
    }

    .about-containerSeven-Three img {
        width: 12%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/About.css"],"names":[],"mappings":";AACA,QAAQ;AACR;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;AACd;;AAEA,YAAY;;AAEZ;IACI;QACI,aAAa;QACb,qCAAqC;QACrC,wBAAwB;QACxB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,qCAAqC;QACrC,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;;QAEI,YAAY;QACZ,eAAe;QACf,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,QAAQ;;AAER;IACI,WAAW;IACX,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wEAAwE;AAC5E;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA,kBAAkB;AAClB;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,uEAAuE;IAC3E;;IAEA;QACI,SAAS;QACT,SAAS;QACT,iBAAiB;QACjB,oBAAoB;QACpB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,wCAAwC;QACxC,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,wEAAwE;IAC5E;;IAEA;QACI,SAAS;QACT,SAAS;QACT,aAAa;QACb,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,YAAY;IAChB;;AAEJ;;;AAGA,MAAM;;AAEN;IACI,eAAe;IACf,uCAAuC;IACvC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;;AAGA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;;AAGJ;;AAEA,MAAM;AACN;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,YAAY;;AAEZ;IACI;QACI,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,oBAAoB;IACxB;;;IAGA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;;;;;AAKA,MAAM;AACN;IACI,yBAAyB;IACzB,uCAAuC;IACvC,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,WAAW;;AAEX;IACI;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,6BAA6B;QAC7B,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,qCAAqC;QACrC,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB;IACJ;;AAEJ;;;AAGA,MAAM;;AAEN;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA,YAAY;;AAEZ;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,8BAA8B;QAC9B,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;;;AAIA,MAAM;AACN;IACI,eAAe;IACf,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;;IAEjB;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA,QAAQ;AACR;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA,WAAW;AACX;;IAEI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,wCAAwC;QACxC,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;QACpB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,SAAO;IACX;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,aAAa;QACb,SAAO;QACP,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA,SAAS;IACT;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;IACtB;;;IAGA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,wCAAwC;QACxC,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["\r\n/* One */\r\n.about-containerOne {\r\n    display: flex;\r\n    column-gap: 70px;\r\n    margin: 0px 10%;\r\n    margin-top: 250px;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.about-container-one {\r\n    width: 50%;\r\n    padding-right: 50px;\r\n}\r\n\r\n.about-container-subone {\r\n    font-size: 28px;\r\n    font-weight: 800;\r\n    line-height: 35.28px;\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.about-container-subtwo {\r\n    margin-top: 12px;\r\n    margin-bottom: 0px;\r\n    line-height: 83px;\r\n    font-size: 70px;\r\n    font-weight: 200;\r\n}\r\n\r\n.about-container-subthree {\r\n    margin: 0px;\r\n    font-size: 70px;\r\n    font-weight: 800;\r\n    line-height: 1;\r\n}\r\n\r\n.about-container-subfour {\r\n    margin-top: 26px;\r\n    margin-bottom: 45px;\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n    line-height: 42px;\r\n    letter-spacing: 4%;\r\n}\r\n\r\n.about-container-subfive {\r\n    display: flex;\r\n    gap: 13px;\r\n    line-height: 1;\r\n}\r\n\r\n.about-container-btnone,\r\n.about-container-btntwo {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 60px;\r\n    border-radius: 50px;\r\n    font-size: 18px;\r\n}\r\n\r\n.about-container-btnone {\r\n    padding: 25px, 52px, 26px, 52px;\r\n    width: 196px;\r\n    color: white;\r\n    background-color: #20303F;\r\n    border: none;\r\n\r\n}\r\n\r\n.about-container-btntwo {\r\n    width: 216px;\r\n    color: black;\r\n    background-color: white;\r\n    padding-left: 8px, 10px, 8px, 10px;\r\n}\r\n\r\n.about-container-two {\r\n    width: 100%;\r\n    height: 500px;\r\n    width: 500px;\r\n    display: flex;\r\n}\r\n\r\n.about-container-two img {\r\n    padding-top: 40px;\r\n    margin-bottom: -75px;\r\n    width: 100;\r\n}\r\n\r\n/* media 1 */\r\n\r\n@media (max-width: 1280px) {\r\n    .about-containerOne {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        grid-template-rows: auto;\r\n        padding: 0px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .about-container-one {\r\n        width: 100%;\r\n        padding-right: 50px;\r\n    }\r\n\r\n    .about-container-two {\r\n        margin-left: 0px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerOne {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        overflow: hidden;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .about-container-subone {\r\n        margin-top: 0px;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .about-container-subtwo {\r\n        width: 100vw;\r\n        margin-top: 6px;\r\n        margin-bottom: 0px;\r\n        line-height: 1;\r\n        font-size: 35px;\r\n        font-weight: lighter;\r\n    }\r\n\r\n    .about-container-subthree {\r\n        width: 80vw;\r\n        margin-top: 5px;\r\n        font-size: 35px;\r\n    }\r\n\r\n    .about-container-subfour {\r\n        width: 80vw;\r\n        margin-top: 13px;\r\n        margin-bottom: 23px;\r\n        font-size: 16px;\r\n        font-weight: normal;\r\n        line-height: 20px;\r\n    }\r\n\r\n    .about-container-two {\r\n        width: 75%;\r\n    }\r\n\r\n    .about-container-two img {\r\n        width: 100vw;\r\n        height: 40vh;\r\n    }\r\n\r\n    .about-container-btnone,\r\n    .about-container-btntwo {\r\n        height: 45px;\r\n        font-size: 10px;\r\n        padding: 0%;\r\n    }\r\n\r\n    .about-container-btnone {\r\n        width: 120px;\r\n        color: white;\r\n    }\r\n\r\n    .about-container-btntwo {\r\n        width: 130px;\r\n        color: black;\r\n    }\r\n    .about-container-two {\r\n        height: auto;\r\n    }\r\n}\r\n\r\n/* two */\r\n\r\n.about-containerTwo {\r\n    width: 100%;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    position: relative;\r\n}\r\n\r\n.HadnShakeimg {\r\n    width: 100%;\r\n    object-fit: cover;\r\n    clip-path: polygon(10% 0%, 100% 0%, 100% 80%, 90% 100%, 0% 100%, 0% 20%);\r\n}\r\n\r\n.about-containerTwo-one {\r\n    position: absolute;\r\n    bottom: -50px;\r\n    left: 28%;\r\n    transform: translateX(-50%);\r\n    background: #0B63E5;\r\n    color: white;\r\n    border-top-right-radius: 50px;\r\n    padding: 1% 2% 1% 2%;\r\n    width: 35%;\r\n}\r\n\r\n.logoT {\r\n    width: 120px;\r\n    height: 25px;\r\n}\r\n\r\n.about-containerTwo-line1 {\r\n    margin-top: 20px;\r\n    margin-bottom: 0px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.about-containerTwo-line2 {\r\n    margin-top: 0px;\r\n    font-size: 40px;\r\n    font-weight: lighter;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.about-containerTwo-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.getConnected-button {\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #20303F;\r\n    padding: 20px 40px 20px 40px;\r\n    border: none;\r\n    border-radius: 50px;\r\n}\r\n\r\n.about-containerTwo-bottom>img {\r\n    width: 20%;\r\n}\r\n\r\n/* Media for 2nd */\r\n@media (max-width: 1280px) {\r\n\r\n    .about-containerTwo {\r\n        height: 300px;\r\n    }\r\n\r\n    .HadnShakeimg {\r\n        clip-path: polygon(5% 0%, 100% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 20%);\r\n    }\r\n\r\n    .about-containerTwo-one {\r\n        top: 70px;\r\n        left: 50%;\r\n        border-radius: 0%;\r\n        padding: 1% 1% 4% 2%;\r\n        width: 75vw;\r\n        height: 60%;\r\n    }\r\n\r\n    .logoT {\r\n        width: 70px;\r\n        height: 15px;\r\n    }\r\n\r\n    .about-containerTwo-line1 {\r\n        margin-top: 12px;\r\n        margin-bottom: 0px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .about-containerTwo-line2 {\r\n        font-size: 25px;\r\n        line-height: 30px;\r\n        font-weight: 200;\r\n    }\r\n\r\n    .about-containerTwo-line2 span {\r\n        font-size: 25px;\r\n        line-height: 30px;\r\n        font-weight: 800;\r\n    }\r\n\r\n    .getConnected-button {\r\n        padding: 10.42px 21.67px 10.83px 21.67px;\r\n        font-size: 14px;\r\n        font-weight: 800;\r\n        line-height: 20.37px;\r\n    }\r\n\r\n    .about-containerTwo-bottom>img {\r\n        width: 10%;\r\n        margin-top: 4%;\r\n        height: 70px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerTwo {\r\n        margin-top: -100px;\r\n        margin-bottom: 400px;\r\n    }\r\n\r\n    .about-containerTwo {\r\n        height: 400px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .HadnShakeimg {\r\n        width: 100%;\r\n        object-fit: cover;\r\n        clip-path: polygon(10% 0%, 100% 0%, 100% 80%, 90% 100%, 0% 100%, 0% 20%);\r\n    }\r\n\r\n    .about-containerTwo-one {\r\n        top: 70px;\r\n        left: 50%;\r\n        height: 250px;\r\n        width: 280px;\r\n        padding: 5% 5% 4% 2%;\r\n    }\r\n\r\n    .about-containerTwo-bottom>img {\r\n        width: 20%;\r\n        margin-top: 5%;\r\n        height: 50px;\r\n    }\r\n\r\n}\r\n\r\n\r\n/* 3 */\r\n\r\n.about-containerThree {\r\n    margin: 0px 10%;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    display: flex;\r\n    column-gap: 10px;\r\n}\r\n\r\n.about-containerThree-Container {\r\n    width: 50%;\r\n}\r\n\r\n.about-containerThree-Line1 {\r\n    font-size: 25px;\r\n    font-weight: bold;\r\n    margin-top: 35px;\r\n}\r\n\r\n.about-containerThree-Line2 {\r\n    font-size: 23px;\r\n    margin-bottom: 0px;\r\n    margin-top: 36px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.about-containerThree-Line3 {\r\n    font-weight: bolder;\r\n    font-style: italic;\r\n}\r\n\r\n.about-containerThree-Line4 {\r\n    font-weight: bold;\r\n    display: block;\r\n}\r\n\r\n.about-containerThree-Container2 {\r\n    display: flex;\r\n    justify-content: right;\r\n}\r\n\r\n.about-containerThree-three {\r\n    background-color: #F3F7FF;\r\n    width: 50%;\r\n}\r\n\r\n.about-containerThree-threeone {\r\n    margin-top: -12%;\r\n    padding: 1%;\r\n    display: flex;\r\n    font-size: 24px;\r\n    column-gap: 15px;\r\n}\r\n\r\n.about-containerThree-threeone img {\r\n    margin-top: 60%;\r\n    height: 85%;\r\n}\r\n\r\n.about-containerThree-threeone-logo {\r\n    margin: -10px -10px 0px 0px;\r\n    display: flex;\r\n    justify-content: right;\r\n}\r\n\r\n.about-containerThree-threeone-line1 {\r\n    font-weight: bolder;\r\n    margin-top: 15px;\r\n}\r\n\r\n.about-containerThree-threeone-line2 {\r\n    font-weight: bold;\r\n    margin-top: 9%;\r\n}\r\n\r\n.about-containerThree-threeone-line2+p {\r\n    margin-top: 80px;\r\n}\r\n\r\n/* Media for 3rd */\r\n@media (max-width: 1280px) {\r\n    .about-containerThree {\r\n        margin-top: 90px;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .about-containerThree-Container {\r\n        width: 100%;\r\n        margin-top: 2%;\r\n    }\r\n\r\n    .about-containerThree-three {\r\n        background-color: #F3F7FF;\r\n        width: 100%;\r\n    }\r\n\r\n    .about-containerThree-threeone-logo {\r\n        margin: -25px -25px 0px 0px;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerThree {\r\n        margin-top: -350px;\r\n    }\r\n\r\n    .about-containerThree-Line1 {\r\n        margin-top: 0px;\r\n        font-size: 15px;\r\n        font-weight: 800;\r\n        line-height: 18px;\r\n    }\r\n\r\n    .about-containerThree-Line2 {\r\n        margin-top: 20px;\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 18px;\r\n    }\r\n\r\n    .about-containerThree-Line3 {\r\n        font-weight: 800;\r\n    }\r\n\r\n    .about-containerThree-Container2 img {\r\n        width: 100%;\r\n    }\r\n\r\n    .about-containerThree-threeone {\r\n        padding: 1%;\r\n        padding-top: 30px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n        line-height: 15.29px;\r\n        height: 250px;\r\n    }\r\n\r\n    .about-containerThree-threeone-line1 {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .about-containerThree-threeone-line2 {\r\n        font-size: 12.14px;\r\n        font-weight: 600;\r\n        line-height: 18.27px;\r\n    }\r\n\r\n    .about-containerThree-threeone-line2+p {\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .about-containerThree-threeone img {\r\n        padding-left: 10%;\r\n        margin-right: 15px;\r\n        margin-top: 10px;\r\n        height: 100%;\r\n    }\r\n\r\n    .about-containerThree-threeone {\r\n        column-gap: 0px;\r\n    }\r\n\r\n    .about-containerThree-threeone-logo {\r\n        height: 60px;\r\n        margin: -20px -10px 0px 0px;\r\n    }\r\n\r\n\r\n}\r\n\r\n/* 4 */\r\n.about-containerFour {\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.about-containerFour-headLines {\r\n    margin: 0% 10%;\r\n    font-size: 45px;\r\n    font-weight: 200;\r\n    text-align: center;\r\n}\r\n\r\n.about-containerFourPhoto img {\r\n    width: 100px;\r\n    margin-bottom: -20px;\r\n}\r\n\r\n.about-containerFourbottom {\r\n    font-size: 36px;\r\n    text-align: center;\r\n}\r\n\r\n.about-containerFourbottom-IT>img {\r\n    margin-bottom: -2px;\r\n}\r\n\r\n.about-containerFourbottompart2 {\r\n    font-weight: bolder;\r\n}\r\n\r\n.about-containerFourbottom2 {\r\n    text-align: center;\r\n    margin-top: -20px;\r\n}\r\n\r\n/* Media  4*/\r\n\r\n@media (max-width: 1280px) {\r\n    .about-containerFour-headLines {\r\n        margin: 0% 15%;\r\n        font-size: 30px;\r\n        line-height: 2;\r\n    }\r\n\r\n    .about-containerFourPhoto img {\r\n        width: 60px;\r\n        margin-bottom: -15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerFour {\r\n        margin-top: -100px;\r\n        margin-bottom: -200px;\r\n    }\r\n\r\n    .about-containerFour-headLines {\r\n        margin: 0% 10%;\r\n        font-size: 18.17px;\r\n        font-weight: 200;\r\n        line-height: 30.29px;\r\n        margin-top: 50px;\r\n    }\r\n\r\n    .about-containerFourPhoto img {\r\n        width: 40px;\r\n        margin-bottom: -15px;\r\n    }\r\n\r\n\r\n    .about-containerFourbottom {\r\n        font-size: 14px;\r\n        font-weight: 200;\r\n        line-height: 12.11px;\r\n        margin-top: 40px;\r\n    }\r\n\r\n    .about-containerFourbottom2 {\r\n        margin-top: -10px;\r\n    }\r\n\r\n    .about-containerFourbottom-IT img {\r\n        width: 0.6rem;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n/* 5 */\r\n.about-containerFive {\r\n    background-color: #0B63E5;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    font-size: 20px;\r\n    color: white;\r\n    font-weight: 500;\r\n}\r\n\r\n.about-containerFivePartone {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n}\r\n\r\n.about-containerFiveParttwo {\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n}\r\n\r\n.about-containerFivePartone-icon {\r\n    margin-top: 12px;\r\n}\r\n\r\n.about-containerFivePartone-item {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n/* Media5 */\r\n\r\n@media (max-width: 1280px) {\r\n    .about-containerFivePartone {\r\n        display: grid;\r\n        grid-template-columns: repeat(5, 4fr);\r\n    }\r\n\r\n    .about-containerFivePartone div {\r\n        justify-content: space-around;\r\n        margin: 0% 5%;\r\n    }\r\n\r\n    .about-containerFiveParttwo {\r\n        border-top: 2px solid;\r\n        display: grid;\r\n        grid-template-columns: repeat(3, 4fr);\r\n        margin: 0% 1%;\r\n    }\r\n\r\n    .about-containerFiveParttwo div {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerFivePartone {\r\n        font-size: 8px;\r\n        font-weight: 500;\r\n        line-height: 15.85px;\r\n    }\r\n\r\n    .about-containerFiveParttwo {\r\n        font-size: 8px;\r\n        font-weight: 500;\r\n        line-height: 15.85px\r\n    }\r\n\r\n}\r\n\r\n\r\n/* 6 */\r\n\r\n.about-containerSix {\r\n    width: 80%;\r\n    display: flex;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    /* column-gap: 50px; */\r\n}\r\n\r\n.about-containerSix-one {\r\n    width: 60%;\r\n}\r\n\r\n.about-containerSix-one-info {\r\n    font-size: 48px;\r\n}\r\n\r\n.about-containerSix-one-Title {\r\n    margin: 0px;\r\n    font-size: 31.39px;\r\n    font-weight: 200;\r\n    line-height: 35.32px;\r\n}\r\n\r\n.about-containerSix-one-Subtitle {\r\n    font-weight: bolder;\r\n    margin: 0px;\r\n}\r\n\r\n.about-containerSix-one-data {\r\n    margin-top: 75px;\r\n    display: flex;\r\n    column-gap: 1%;\r\n    padding-right: 1%;\r\n}\r\n\r\n.dataimg {\r\n    height: 45px;\r\n    width: 48px;\r\n}\r\n\r\n.about-containerSix-one-dataTitle {\r\n    font-size: 28px;\r\n\r\n}\r\n\r\n.about-containerSix-one-datasubtitle {\r\n    font-size: 20px;\r\n}\r\n\r\n.about-containerSix-two img {\r\n    width: 100%;\r\n    height: 95%;\r\n}\r\n\r\n/* media 6 */\r\n\r\n@media (max-width: 1280px) {\r\n    .about-containerSix {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .about-containerSix-one {\r\n        width: 100%;\r\n    }\r\n\r\n    .about-containerSix-one-data {\r\n        margin-top: 50px;\r\n        display: flex;\r\n        column-gap: 1%;\r\n        justify-content: space-between;\r\n        padding-right: 0px;\r\n        column-width: 100px;\r\n    }\r\n\r\n    .about-containerSix-two {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    .about-containerSix-two img {\r\n        width: 80%;\r\n        margin-top: 70px;\r\n        border-top: 1px solid;\r\n    }\r\n\r\n    .about-containerSix-one-data>div {\r\n        width: 100%;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerSix {\r\n        margin-top: 100px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-bottom:80px;\r\n    }\r\n    \r\n\r\n    .about-containerSix-one {\r\n        width: 100%;\r\n    }\r\n\r\n    .about-containerSix-one-info {\r\n        font-size: 31.39px;\r\n        line-height: 35.32px;\r\n    }\r\n\r\n    .about-containerSix-one-Subtitle {\r\n        font-weight: 800;\r\n    }\r\n\r\n    .about-containerSix-one-data {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .about-containerSix-one-data-media {\r\n        display: flex;\r\n        justify-content: space-evenly;\r\n        align-items: center;\r\n    }\r\n\r\n    .about-containerSix-one-data {\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .about-containerSix-one-data>div {\r\n        border-top: 1px solid;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .about-containerSix-one-dataTitle {\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n        line-height: 18.13px;\r\n    }\r\n\r\n    .about-containerSix-one-datasubtitle {\r\n        font-size: 13.08px;\r\n        font-weight: 400;\r\n        line-height: 19.68px;\r\n    }\r\n\r\n    .about-containerSix-two {\r\n        width: 100%;\r\n        display: flex;\r\n        margin-top: 20px;\r\n        border-top: 1px solid;\r\n    }\r\n\r\n    .about-containerSix-two img {\r\n        width: 100%;\r\n        margin: auto;\r\n    }\r\n\r\n    .dataimg {\r\n        width: 15%;\r\n    }\r\n}\r\n\r\n\r\n\r\n/* 7 */\r\n.about-containerSeven {\r\n    padding: 0% 10%;\r\n    background-color: #0B63E5;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.about-containerSeven-one {\r\n    font-size: 48px;\r\n    padding-top: 120px;\r\n    color: white;\r\n    text-align: center;\r\n    font-family: Plus Jakarta Sans;\r\n}\r\n\r\n.about-containerSeven-oneTitle {\r\n    font-weight: lighter;\r\n    margin-bottom: 0px;\r\n    margin-top: 0px;\r\n}\r\n\r\n.about-containerSeven-oneSubtitle {\r\n    font-weight: bold;\r\n    margin-top: 0px;\r\n}\r\n\r\n.about-containerSeven-two {\r\n    display: flex;\r\n    column-gap: 30px;\r\n    margin-bottom: 45px;\r\n}\r\n\r\n.about-containerSeven-two div {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n}\r\n\r\n.about-containerSeven-twoBlog {\r\n    padding: 3% 2%;\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n\r\n.about-containerSeven-two-blog {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    column-gap: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 32px;\r\n    font-weight: bold;\r\n\r\n    & img {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.about-containerSeven-two-blog div>p {\r\n    margin-top: 0px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.about-containerSeven-twoBlog-info {\r\n    font-size: 20px;\r\n    font-weight: normal;\r\n}\r\n\r\n.about-containerSeven-twoBlog-info p {\r\n    margin-top: 0px;\r\n    margin-bottom: 45px;\r\n}\r\n\r\n.about-containerSeven-twoBlog-Person {\r\n    display: flex;\r\n    column-gap: 15px;\r\n    align-items: center;\r\n}\r\n\r\n.about-containerSeven-twoBlog-Person div img {\r\n    width: 72px;\r\n}\r\n\r\n.about-containerSeven-twoBlogName p {\r\n    font-size: 24px;\r\n    line-height: 25px;\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.about-containerSeven-twoBlogPosition p {\r\n    font-size: 20px;\r\n    margin-top: 5px;\r\n    margin-bottom: 0px;\r\n    line-height: 25px;\r\n}\r\n\r\n.about-containerSeven-Three {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.about-containerSeven-Three {\r\n    font-size: 36px;\r\n    font-weight: 600;\r\n    margin-top: 27px;\r\n    color: white;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.about-containerSeven-Three p {\r\n    margin-top: 0px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.ViewCareers-button {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    color: white;\r\n    background-color: #20303F;\r\n    padding: 5px 40px;\r\n    border: none;\r\n    border-radius: 50px;\r\n    height: 70px;\r\n}\r\n\r\n/* key */\r\n@keyframes scroll {\r\n    0% {\r\n        transform: translateX(100%);\r\n    }\r\n\r\n    100% {\r\n        transform: translateX(-100%);\r\n    }\r\n}\r\n\r\n#marquee {\r\n    display: flex;\r\n    animation: scroll 20s linear infinite;\r\n}\r\n\r\n/* media7 */\r\n@media (max-width: 1280px) {\r\n\r\n    .about-containerSeven {\r\n        height: auto;\r\n        padding: 0%;\r\n        overflow: scroll;\r\n    }\r\n\r\n    .about-containerSeven-two {\r\n        justify-content: space-around;\r\n    }\r\n\r\n    #marquee .about-containerSeven-twoBlog {\r\n        white-space: normal;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .ViewCareers-button {\r\n        width: 50%;\r\n        padding: 11.79px 24.53px 12.27px 24.53px;\r\n        gap: 8.57px;\r\n        font-size: 18px;\r\n        font-weight: 800;\r\n        line-height: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .about-containerSeven {\r\n        padding: 5% 4% 10% 4%;\r\n        overflow: scroll;\r\n        margin-bottom:0px;\r\n    }\r\n\r\n    .about-containerSeven-one {\r\n        font-size: 32px;\r\n        padding-top: 50px;\r\n        font-weight: 200;\r\n        line-height: 24.54px;\r\n    }\r\n\r\n    .about-containerSeven-oneTitle {\r\n        font-weight: 200;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .about-containerSeven-oneSubtitle {\r\n        font-weight: 800;\r\n    }\r\n\r\n    .about-containerSeven-two {\r\n        display: flex;\r\n        column-gap: 50px;\r\n    }\r\n\r\n    .about-containerSeven-two-blog {\r\n        font-size: 20.6px;\r\n        font-weight: 700;\r\n        line-height: 22.53px;\r\n    }\r\n\r\n    .about-containerSeven-twoBlog-info {\r\n        font-size: 12.88px;\r\n        font-weight: 400;\r\n        line-height: 17.63px;\r\n        margin-bottom: -30px;\r\n    }\r\n\r\n    .about-containerSeven-twoBlogName p {\r\n        font-size: 15.45px;\r\n        font-weight: 700;\r\n        line-height: 16.53px;\r\n    }\r\n\r\n    .about-containerSeven-twoBlogPosition p {\r\n        font-size: 12.88px;\r\n        font-weight: 400;\r\n        line-height: 16.46px;\r\n    }\r\n\r\n    .about-containerSeven-twoBlog-Person div img {\r\n        width: 50px;\r\n    }\r\n\r\n    .about-containerSeven-two-blog img {\r\n        width: 60px;\r\n    }\r\n\r\n    .about-containerSeven-twoBlog {\r\n        display: flex;\r\n        flex: 1;\r\n    }\r\n\r\n    #marquee .about-containerSeven-twoBlog {\r\n        display: inline-block;\r\n        white-space: normal;\r\n        display: flex;\r\n        flex: 1;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    /*Last  */\r\n    .about-containerSeven-Three {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .about-containerSeven-Three p {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n\r\n    .about-containerSeven-Three {\r\n        padding-bottom: 10px;\r\n        margin-bottom: 0px;\r\n        font-size: 21px;\r\n        font-weight: 600;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    .ViewCareers-button {\r\n        height: 50px;\r\n        width: 50%;\r\n        padding: 11.79px 24.53px 12.27px 24.53px;\r\n        gap: 8.57px;\r\n        font-size: 11.01px;\r\n        font-weight: 800;\r\n        line-height: 16.02px;\r\n    }\r\n\r\n    .about-containerSeven-Three img {\r\n        width: 12%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
